import React from "react";

export default ({ isLogin }) => <div className="loader__container">
    <div className="loader__progress" data-cy="loader">
        <div className={isLogin ? 'loader--light' : 'loader'} />
        <p className={("mt-3 mb-0 ") + (isLogin ? 'text-white' : 'text-muted')}>We are loading your data.</p>
    </div>
</div>
